import { useEffect } from 'react';

export const ErrorTest = () => {
    useEffect(() => {
        throw new Error('Test error for ErrorBoundary');
    }, []);

    return <div>This text should never be shown</div>;
};